import(/* webpackMode: "eager", webpackExports: ["CalendarPage"] */ "/app/components/calendar/calendar-page.tsx");
